import axios from 'axios';
import CryptoService from './crypto-services';
import { StorageKeys } from '@/constants';

const cryptoService = new CryptoService();
const gatewayURL = process.env.VUE_APP_GATEWAY_URL;
const ActionListRemoteURL = process.env.VUE_APP_Actionlist_URL;
const RemoteURL = process.env.VUE_APP_REMOTE_URL;

const ActionListClient_Audience = process.env.VUE_APP_ActionListClient_Audience;
const BookingClient_Audience = process.env.VUE_APP_BookingClient_Audience;

const BookingClient_ID = process.env.VUE_APP_BookingClient_ID;
const BookingClient_Sceret = process.env.VUE_APP_BookingClient_Sceret;


export default class RequestHelperService {
  defaultUIDefIDKey: string = process.env.VUE_APP_UI_DEF_ID;

  defaultCustomerKey: string = process.env.VUE_APP_CUSTOMER_ID;

  baseURL = process.env.VUE_APP_GATEWAY_BASE_URL;
  private actionlistURL = 'actionlist';

  localStorageAgrislicense = {
    username: '',
    password: '',
    beforeEncrptPassword: '',
    agrisLicense: '',
  };

  GetAgentSessionId(SessionID = null): Promise<any> {
    return new Promise((resolve, reject) => {
      const agentInfo = JSON.parse(localStorage.agentInfo);
      this.GetActivation(agentInfo.agentUser, agentInfo.agentPassword, 'AgrisSales').then((data) => {
        const payload = {
          Password: data.MoreInfo.Password,
          Username: data.MoreInfo.UserName,
          DeviceName: 'HOPPER',
          CustomerID: process.env.VUE_APP_CUSTOMER_ID,
          SessionID,
          UIDefID: '45366299-9083-497b-8343-a8f701521358',
        };
        const baseURL = process.env.VUE_APP_GATEWAY_BASE_URL;
        axios.post(`${baseURL}/culturahub/RESTSecurityWebService/Authenticate`, payload, { headers: { SessionID } }).then((response: any) => {
          const settings = JSON.parse(localStorage.getItem('agentInfo'));
          if (response && response.data) {
            settings.SessionID = response.data.SessionID;
            if (settings) settings.agentSessionDate = new Date().toLocaleDateString();
            localStorage.setItem('agentInfo', JSON.stringify(settings));
            resolve(settings.SessionID);
          }
        }).catch((e) => {
          const settings = JSON.parse(localStorage.getItem('agentInfo'));
          resolve(settings.SessionID);
        });
      });
    });
  }

  async refreshAgrisLicenseCounter(): Promise<any> {
    const refreshLicense = localStorage.getItem('RefreshAgrisLicense');

    if (refreshLicense === 'true') {
      return true;
    }

    localStorage.setItem('RefreshAgrisLicense', 'true');

    const response: any = await this.refreshAgrisLicense();
    localStorage.setItem('RefreshAgrisLicense', 'false');
    if (response == true) return true;
    return false;
    // reject('License count exceeded. To continue using the app, contact your administrator to ensure there are enough licenses available before retrying.');
  }

  private async refreshAgrisLicense() {
    try {
      const agentInfo = JSON.parse(localStorage.agentInfo);
      const userInfo = JSON.parse(localStorage.usertData);

      const tenantId = agentInfo.TenantId;
      this.localStorageAgrislicense = {
        username: userInfo.userEmail,
        password: userInfo.Password,
        beforeEncrptPassword: '6',
        agrisLicense: userInfo.AgrisSessionId,
      };

      if (!this.localStorageAgrislicense.username) return false;

      const agrisLicense: any = this.localStorageAgrislicense || {};
      this.refreshAgris().then(response => {
        if (response && response.Message == 'True') {
          const license = {
            username: agrisLicense.username,
            password: agrisLicense.password,
            beforeEncrptPassword: agrisLicense.beforeEncrptPassword,
            agrisLicense: response.ResultString,
          };
          Object.assign(this.localStorageAgrislicense, license);
          const userInfo = JSON.parse(localStorage.usertData);
          userInfo.AgrisSessionId = this.localStorageAgrislicense.agrisLicense;
          localStorage.setItem('usertData', JSON.stringify(userInfo));
          return true;
        }
      })
    } catch (ex) {
      console.log(ex);
    }
    return false;
  }
  refreshAgris(): Promise<any> {

    var promise = new Promise(function (resolve, reject) {

      var agentInfo = JSON.parse(localStorage.agentInfo);
      const userInfo = JSON.parse(localStorage.usertData);
      const agrisSessiontID = userInfo.AgrisSessionId;
      let body = {
        "TenantID": agentInfo.TenantId,
        "UserID": userInfo.userEmail,
        "Password": userInfo.Password,
        "ExtendedOption": "nko",
        "ExtendedOptionValue": "NAM12",
        "SessionID": agentInfo.SessionID,
        "AgrisSession": agrisSessiontID
      }

      this.Post(`${RemoteURL}/api/AgrisLicense/RefreshLicense`, body, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
        .then(response => {
          resolve(response.data.TransactionObject);
        }).catch(e => {
          reject(e);
        })
    });

    return promise;
  }
  PostCommand(remoteURL: string, payload: any, headers: any = null): Promise<any> {
    if (payload) {
      const userInfo = JSON.parse(localStorage.usertData);
      const agentInfo = JSON.parse(localStorage.agentInfo);

      payload.User = userInfo.userEmail;
      payload.Password = userInfo.Password;
      payload.AgrisSession = userInfo.AgrisSessionId;
      payload.SessionId = agentInfo.SessionID;
      payload.TenantId = agentInfo.TenantId;

      headers = {
        SessionID: payload.SessionId,
      };
    } else {
      payload = { CustomerID: 'C93F949C-41B8-4C9E-95AA-B030B31F6F3F' };
    }
    return new Promise((resolve, reject) => {
      // if (remoteURL.includes(this.actionlistURL)) {
      //   let auth0: string | null = null;
      //   let authexpiry: number | null = null;

      //   let token = localStorage.getItem(StorageKeys.AuthToken);

      //   remoteURL = remoteURL.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);

      //   if (token) {
      //     const parsedToken = JSON.parse(token);
      //     auth0 = parsedToken.Token;
      //     authexpiry = parsedToken.Expire; // Assuming `Expire` is in Unix timestamp format (milliseconds)
      //   }
      //   const date = new Date(authexpiry);
      //   const millisecondsAuthexpiry = date.getTime();
      //   // Convert authexpiry and current time to UTC
      //   const currentUtcTime = new Date().getTime(); // Current UTC time in milliseconds
      //   const authexpiryUtc = millisecondsAuthexpiry || 0; // Ensure it's not null

      //   // Check if the token is missing or expired
      //   if (!auth0 || authexpiryUtc < currentUtcTime) {
      //     auth0 = await this.GetAuthToken(remoteURL);
      //   }

      //   // Set the Authorization header if the token is available
      //   if (auth0) {
      //     headers = headers.set("Authorization", 'Bearer ' + cryptoService.dencryptString(auth0));
      //   }
      // }
      axios.post(`${remoteURL}`, payload, { headers }).then(
        (response: any) => {
          resolve(response.data);
        },
      ).catch((e) => {
        reject(e);
      });
    });
  }

  GetActivation(clientEmail, clientPassword, Appname): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      // clientPassword = encodeURIComponent(this.crypt.encryptString(clientPassword));
      clientPassword = encodeURIComponent(clientPassword);
      this.GetAdminSessionId().then((adminSessionId) => {
        let body = {
          "AgentEmail": clientEmail,
          "AgentEncryptedPassword": clientPassword,
        }
        this.Post(`${RemoteURL}/api/AgrisLicense/ActivateApp`, body, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
          .then(response => {
            response = JSON.parse(response);
            resolve(response);
          }).catch(e => {
            reject(e);
          })
        // const url = `${gatewayURL}/RESTCommandWebService/ExecuteServerCommand/ActivationsCommandProcessor/ActivateApp?AgentEmail=${clientEmail}&AgentPassword=${clientPassword}&AppName=${Appname}&AppVersion=1.0.0`;
        // this.PostCommand(url, null, { SessionID: adminSessionId }).then((data) => { resolve(data); }, (response) => {
      });
    });
    return promise;
  }
  GetAdminSessionId(): Promise<any> {
    const promise = new Promise((resolve, reject) => {
      // clientPassword = encodeURIComponent(this.crypt.encryptString(clientPassword));
      const remoteURL = `${gatewayURL}/RESTSecurityWebService/Authenticate`;

      axios.post(remoteURL, {
        Password: 'TLJUFZIZQPB+u9y1mPfmSw==',
        Username: 'apiAdmin',
        DeviceName: 'HOPPER',
        UIDefID: '45366299-9083-497b-8343-a8f701521358',
        CustomerID: 'C93F949C-41B8-4C9E-95AA-B030B31F6F3F',
        SessionID: null,
      }).then(
        (response: any) => {
          resolve(response.data.SessionID);
        },
      ).catch((e) => {
        reject(e);
      });
    });
    return promise;
  }

  async Get(remoteUrl: string, _body: any, customerKey: any, SessionID: any, TenantID: any, SelectedEntities: any, Options: any, uiDefId: any, isHttp = false, islogOff = false, isQuniqueUrl = false, isAuthCall = false,headers =({}) ): Promise<any> {

    let promise = new Promise(async (resolve, reject) => {
      
      if (headers && Object.keys(headers).length > 0) {

      } else {
        headers = ({})
      }  
      

      if (customerKey) Object.assign(headers, { "CustomerID": customerKey });
      if (SessionID) Object.assign(headers, { "SessionID": SessionID });
      if (TenantID) Object.assign(headers, { "TenantID": TenantID });
      if (SelectedEntities) Object.assign(headers, { "SelectedEntities": SelectedEntities });
      if (Options) Object.assign(headers, { "Options": Options });

      let protocol = "";
      if (remoteUrl.indexOf('http://') === 0 || remoteUrl.indexOf('https://') === 0) {

      } else {
        protocol = isHttp || remoteUrl.indexOf('localhost') === 0 ? 'http://' : 'https://';
      }



      let url = protocol + remoteUrl;
      if (isQuniqueUrl) {
        url = this.addUniqueQueryParam(url);
      }

      if ((url.includes(`${ActionListRemoteURL}`) || url.includes(`${RemoteURL}`)) && !isAuthCall) {
        let auth0;
        url = url.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);
        auth0 = await this.GetAuthTokenFormLocal(url, SessionID);

        if (auth0) {
          var headerAuthorization = 'Bearer ' + cryptoService.dencryptString(auth0).toString();
          //   console.log(headerAuthorization);
          Object.assign(headers, { "Authorization": headerAuthorization });
        }
      }

      try {

        await axios.get(url, { headers: headers })
          .then((response: any) => {
            if (response && response.status == 200) {
              resolve(response);
            }
            else
              reject(null);
          }).catch(e => {
            //   if (e.response && e.response.data && e.response.data.Code) {
            //       if (e.response.data.Code == 401) {
            //           let sessionId = await this.GetAgentSessionId();
            //           if (sessionId) {
            //               headers.SessionID = sessionId;
            //               this.getDataFromAgentGateway(url, headers);
            //               resolve(true);
            //           }
            //           else
            //               reject(null);
            //       }
            //       else if (e.response.data.Code == 404) {
            //           resolve([]);
            //       }
            //   }
            reject(e);
          });

      } catch (error) {
        reject(error);
      }
    });
    return promise;
  }

  async Post(remoteUrl: string, _body: any, customerKey: any, SessionID: any, TenantID: any, SelectedEntities: any, Options: any, uiDefId: any, isHttp = false, islogOff = false, isQuniqueUrl = false, isAuthCall = false, headers: any = {}): Promise<any> {
    let promise = new Promise(async (resolve, reject) => {
      // var headers: any;

      if (customerKey) Object.assign(headers, { "CustomerID": customerKey });
      if (SessionID) Object.assign(headers, { "SessionID": SessionID });
      if (TenantID) Object.assign(headers, { "TenantID": TenantID });
      if (SelectedEntities) Object.assign(headers, { "SelectedEntities": SelectedEntities });
      if (Options) Object.assign(headers, { "Options": Options });

      let initialBody = {
        CustomerID: customerKey,
        SessionID: SessionID,
        UIDefID: uiDefId,
      };

      let body = SessionID || customerKey || uiDefId ? { ...initialBody, ..._body } : {};
      if (islogOff) {
        headers["SessionID"] = SessionID;
        body = null;
      }

      let protocol = "";
      if (remoteUrl.indexOf('http://') === 0 || remoteUrl.indexOf('https://') === 0) {

      } else {
        protocol = isHttp || remoteUrl.indexOf('localhost') === 0 ? 'http://' : 'https://';
      }

      if (remoteUrl.indexOf("WarehouseDeliveryLocation/InsertUpdateDeliveryLocation")) {
        body = _body;
      }

      let url = protocol + remoteUrl;
      if (isQuniqueUrl) {
        url = this.addUniqueQueryParam(url);
      }

      if ((url.includes(`${ActionListRemoteURL}`) || url.includes(`${RemoteURL}`)) && !isAuthCall) {
        let auth0;
        url = url.replace(/(api\/)([^/]+)/, (match, p1, p2) => `${p1}${p2}V2`);
        auth0 = await this.GetAuthTokenFormLocal(url, SessionID);

        if (auth0) {
          var headerAuthorization = 'Bearer ' + cryptoService.dencryptString(auth0).toString();
          // console.log(headerAuthorization);
          Object.assign(headers, { "Authorization": headerAuthorization });
        }
      }

      try {
        await axios.post(url, body, { headers })
          .then((response: any) => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          })

      } catch (error) {
        reject(error);
      }
    });
    return promise;
  }


  async GetAuthToken(remoteUrl: any, Audience: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      var agentInfo = localStorage.agentInfo ? JSON.parse(localStorage.agentInfo) : null;
      var userInfo = localStorage.usertData ? JSON.parse(localStorage.usertData) : null;

      let tenantId;
      let SessionID;
      let agentId;
      if (agentInfo) {
        tenantId = agentInfo.TenantId;
        SessionID = agentInfo.SessionID;
        agentId = agentInfo.AgentId;
      }
      let username;

      if (userInfo) {
        username = userInfo.userEmail;
      }
      let request: any = {
        tenantId: tenantId,
        agentId: agentId,
        sessionId: SessionID,
        userId: username,
        clientId: BookingClient_ID,
        ClientSecretKey: BookingClient_Sceret,
        ClientAudience: Audience

      };
      let body = {
        EncryptedData: cryptoService.encryptString(JSON.stringify(request))
      }
      const parsedUrl = new URL(`${ActionListRemoteURL}`); // Parse the URL

      let actionListRemote = parsedUrl.hostname; // Extract the hostname
      let url = `${actionListRemote}/actionlistreview/api/Auth/GetAuthToken`;
      try {

        this.Post(url, body, undefined, SessionID, tenantId, undefined, undefined, undefined, false, false, false, true).then(response => {
          if (response && response.data.TransactionObject) {
            if (Audience == `${ActionListClient_Audience}`) {
              localStorage.setItem('TokenForActionListApis', JSON.stringify(response.data.TransactionObject[0]));

            } else {

              localStorage.setItem('TokenForBookingApis', JSON.stringify(response.data.TransactionObject[0]));
            }


            resolve(response.data.TransactionObject[0].Token);
          } else {
            reject(response.ErrorMessage)
          }
        });
      } catch (e: any) {
        let message = `Error-in-GetAuthToken => ${e.message}`;
        console.log(message);
      }
    });
  }

  private addUniqueQueryParam(url: string): string {
    const uniqueParam = `cacheBuster=${new Date().getTime()}`;
    return url.includes('?') ? `${url}&${uniqueParam}` : `${url}?${uniqueParam}`;
  }

  private async GetAuthTokenFormLocal(url: string, SessionID: any): Promise<string> {
    // debugger ;
    let auth0 = null;
    let authexpiry = null;
    let token = null;
    let Audience = null;
    if (url.includes(`${ActionListRemoteURL}`)) {
      token = localStorage.getItem("TokenForActionListApis");
      Audience = `${ActionListClient_Audience}`;
    }
    else if (url.includes(`${RemoteURL}`)) {
      token = localStorage.getItem("TokenForBookingApis");
      Audience = `${BookingClient_Audience}`;
    }

    if (token) {
      const parsedToken = JSON.parse(token);
      auth0 = parsedToken.Token;
      authexpiry = parsedToken.Expire; // Assuming `Expire` is in Unix timestamp format (milliseconds)
    }

    const date = new Date(authexpiry);
    const millisecondsAuthexpiry = date.getTime();
    const currentUtcTime = new Date().getTime(); // Current UTC time in milliseconds
    const authexpiryUtc = millisecondsAuthexpiry || 0;

    if (!auth0 || authexpiryUtc < currentUtcTime) {
      auth0 = await this.GetAuthToken(url, Audience);
    }
    return auth0;
  }



}
